import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlTextProps extends ControlTemplateProps {
    
}

export const ControlText: React.FC<ControlTextProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();

    return (
        <ControlInput type="text" {...ComponentProps(props)} style={{ ...styles.text ?? styles.input, ...props.style }} />        
    );
};